import { Component, useContext, useEffect } from 'react'
import QuestionnaireBuilderContext from '../../../builder/QuestionnaireBuilderProvider'
import QBuilderLayoutComponentWrapper from '../../../builder/Wizard/Layouts/QBuilderLayoutComponentWrapper'
import QCaptureComponentWrapper from './QCaptureComponentWrapper'

export default class QWizardLayout extends Component {
	constructor(props) {
		super(props)
		this.state = {
			details: { ...props.details },
			formData: props.formData,
			navigation: [],
			step: 0,
			activeSections: []
		}

	}

	/*
		Section
	*/
	_renderSections(sections) {
		var ret = []
		for (var i = 0; i < sections.length; i++) {
			ret.push(
				<div
					className={"section flex-column align-items-stretch h-100 w-100 ".concat(this.state.step === i ? 'd-flex' : 'd-none')}>{this._renderSection(sections[i])}</div>)
		}
		return ret
	}

	_renderSection(section) {
		var _section_components = this._renderComponents(section.resources, section)
		return (<div className='text-start'>{_section_components}</div>)
	}
	/*
		Components
	*/
	_checkLayout(component) {
		var _width = 12
		var _offset = 0
		var _layout = []
		try {
			var layout = component.properties.find(p => p.property === 'Layout').values
			if (layout) {
				_layout = JSON.parse(layout)
				_width = _layout.width
				_offset = _layout.offset
			}
		} catch (e) { layout = undefined }
		return { width: _width, offset: _offset, layout: _layout }
	}

	_renderComponents(components, section) {
		var ret = []
		var comps = []
		var _cur_row_width = 0;

		// console.log(components.filter(a => a.resource).map(a => a.resource.id))

		for (const component of components) {
			if (!component.resource) continue
			// var _cache = undefined
			// if (this.props.cachedDetails) {
			// var _component_cached = undefined
			// try {

			// const _sections_filter = JSON.parse(JSON.stringify(this.props.cachedDetails.questionnaire.sections));
			// const _section_cache = _sections_filter
			// .find(s => s.id === section.id)
			// _component_cached =
			// _section_cache.components.find(c => c.id === component.id)
			// } catch (e) { }

			// var _component_responses = { answer: '' }
			// try {
			// var _response = this.props.cachedDetails.responses.find(r => r.answerType.id === component.id)
			// _component_responses = _response ? _response : { answer: '' }
			// } catch (e) {
			// _component_responses = { answer: '' }
			// }
			// var _component_alerts = undefined
			// try {
			// _component_alerts = this.props.cachedDetails.alerts
			// } catch (e) { }

			// _cache = {
			// properties: _component_cached && Object.keys(_component_cached).includes('properties') ? _component_cached.properties : undefined,
			// response: _component_responses,
			// alerts: _component_alerts
			// }
			// }
			const layout = this._checkLayout(component.resource)
			_cur_row_width += layout.width + layout.offset

			comps.push(<QBuilderLayoutComponentWrapper
				currentMode={'Capture'}
				onUpdateLayout={(layout) => { }}
				defaultLayout={layout.layout}
				className={'col-' + layout.width + ' offset-' + layout.offset}
			>
				<QCaptureComponentWrapper
					state={this.state}
					mode={this.props.mode}
					view={this.props.view}//this.props.view
					accessTypes={component.accessTypes}
					// cache={_cache}
					component={component.resource}
					onSetData={(componentId, value, update) => this.props.onSetData(componentId, value, update)}
					activeSubsections={this.props.activeSubsections}
				/>
			</QBuilderLayoutComponentWrapper>)

			if (_cur_row_width >= 12) {
				ret.push(<div className='row'>{comps}</div>)
				comps = []
				_cur_row_width = 0
			}
		}
		ret.push(<div className='row'>{comps}</div>)
		return ret
	}

	/*
		Navigation
	*/
	_handleValidateEvent() {
		var res = true
		for (const fd of this.state.formData) {
			if (fd.section === this.state.step)
				if (fd.validate && !fd.valid)
					res = false
		}
		return res
	}

	_handleNavigation() {
		// Dont show in discover mode
		if (this.props.mode === 'Discover')
			return <></>
		// Check Validation
		// activeSections

		if (this.state.step === 0 && this.state.details.questionnaire.resources.filter(a =>
			a.resource.accessTypes.includes('View')
			|| a.resource.accessTypes.includes('Edit')
			|| a.resource.accessTypes.includes('Inherit')
		).length === 1) {
			// Done
			// if (this._handleValidateEvent())
			return (<ValidateNext questionnaire={this.state.details.questionnaire.resources} section={this.state.step} text='Done' onClick={(e) => {
				this.props.onComplete()
			}
			} className={`btn ng-buttons ${this._handleValidateEvent() ? '' : 'disabled'})`} />

				// <button disabled={!this._handleValidateEvent()} type='button' onClick={(e) => this.props.onComplete()} className={"btn ng-buttons".concat(this._handleValidateEvent() ? '' : 'disabled')}>Done</button>
			)
		}
		else if (this.state.step + 1 === this.state.details.questionnaire.resources.filter(a =>
			a.resource.accessTypes.includes('View')
			|| a.resource.accessTypes.includes('Edit')
			|| a.resource.accessTypes.includes('Inherit')).length) {
			// Done
			return (
				<>
					<button onClick={(e) => this.setState({ step: this.state.step - 1 })} className="btn ng-buttons" >Back</button>
					{/* <button disabled={!this._handleValidateEvent()} type='button' onClick={(e) => this.props.onComplete()} className={"btn ng-buttons".concat(this._handleValidateEvent() ? '' : 'disabled')} >Done</button> */}
					<ValidateNext questionnaire={this.state.details.questionnaire.resources} section={this.state.step} text='Done' onClick={(e) => {
						this.props.onComplete()
						// this.setState({ step: this.state.step + 1 })
					}
					} className={`btn ng-buttons ${this._handleValidateEvent() ? '' : 'disabled'})`} />
				</>
			)
		}
		else if (this.state.step > 0) {
			// Done
			return (
				<>
					<button onClick={(e) => this.setState({ step: this.state.step - 1 })} className="btn ng-buttons" >Back</button>
					<ValidateNext questionnaire={this.state.details.questionnaire.resources} section={this.state.step} text='Next' onClick={(e) => this.setState({ step: this.state.step + 1 })} className={`btn ng-buttons ${this._handleValidateEvent() ? '' : 'disabled'})`} />
					{/* <button disabled={!this._handleValidateEvent()} onClick={} >Next</button> */}
				</>
			)
		} else {
			// Next
			// if (this._handleValidateEvent())
			return (
				<ValidateNext questionnaire={this.state.details.questionnaire.resources} section={this.state.step} text='Next' onClick={(e) => this.setState({ step: this.state.step + 1 })} className={`btn ng-buttons ${this._handleValidateEvent() ? '' : 'disabled'})`} />
				// <button disabled={!this._handleValidateEvent()} onClick={(e) => this.setState({ step: this.state.step + 1 })} className={"btn ng-buttons ".concat(this._handleValidateEvent() ? '' : 'disabled')} >Next</button>

			)
		}
	}

	_handleTitle() {
		var section_title = ''
		try {
			const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_TITLE")
			section_title = this.state.details.questionnaire.resource.resource.name
			if (SHOW_TITLE) {
				var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
				if (SHOW_TITLE_parsed === "None") {
					section_title = "";
				}
				else if (SHOW_TITLE_parsed.type === "Custom Title") {
					section_title = SHOW_TITLE_parsed.title;
				}
			}
		} catch (e) { }
		return section_title
	}

	_handleDescription() {
		var section_title = ''
		try {
			const SHOW_TITLE = this.state.details.options.find(o => o.name === "SHOW_SECTION_TITLE")
			var section_title = this.state.details.questionnaire.resources[this.state.step].resource.resource.name
			if (SHOW_TITLE) {
				var SHOW_TITLE_parsed = JSON.parse(SHOW_TITLE.value)
				if (SHOW_TITLE_parsed === "Hide") {
					section_title = "";
				}
			}
		} catch (e) { }
		return section_title
	}

	render() {
		return (
			<>
				{/* <ToastDialog {...status} />
				<ErrorDialog error={errors} onClose={() => setErrors('')} /> */}
				<div
					className="Wizard top-center position-relative">
					<div className="head"><h1>{this._handleTitle()}</h1>
						<p dangerouslySetInnerHTML={{ __html: this._handleDescription() }}></p>
						<div
							className="error-details"></div>
					</div>
					<div className="body">
						{
							this._renderSections(this.state.details.questionnaire.resources.filter(s =>
								(
									s.resource.accessTypes.includes('View')
									|| s.resource.accessTypes.includes('Edit')
									|| s.resource.accessTypes.includes('Inherit')

								) && s.resource.resource.isSubsection === false
							))
						}

					</div>
					<div className="tail" style={{ minHeight: '38px' }}>
						{
							this._handleNavigation()
						}
					</div>
				</div>
			</>
		)
	}
}


const ValidateNext = ({ questionnaire, section, text, onClick, className }) => {
	const { validated, setSection } = useContext(QuestionnaireBuilderContext)
	useEffect(() => {

		// const filtered = questionnaire.map(a => a.resources.map(a => a.resource.id))[section]
		// console.log('questionnaire.resources****', questionnaire)
		// for (const sect of questionnaire)
		// console.log('*********', filtered)
		setSection(questionnaire.map(a => a.resources.map(a => a.resource.id))[section])


	}, [section])

	useEffect(() => {
		console.log('ValidateNext', validated)

	}, [validated])

	return <button
		// disabled={!this._handleValidateEvent()}
		disabled={!validated}
		onClick={onClick}
		className={`${className} ${!validated ? 'disabled' : ''}`}>{text}</button>
}
